export const useAuth = () => {
  const data = useUserInfo()
  const badges = useUserBadge()
  const premiumExpiredAt = usePremiumExpiredAt()

  function init() {
    if (!data.value || !data.value.login || !data.value.user) {
      data.value = {
        login: false,
        user: {}
      } as User.Info
    }
  }

  async function refresh() {
    const accessToken = useAccessToken().value
    data.value = await fetchUserInfo(accessToken)
  }

  async function refreshBadge() {
    try {
      const res = await fetchUserBadge()

      badges.value = res
      premiumExpiredAt.value =
        (badges.value?.find((badge) => badge.badge_id === 20)?.expire_time ??
          0) * 86400
    } catch (error) {
      console.log(error)
    }
  }
  return {
    data,
    badges,
    premiumExpiredAt,
    init,
    refresh,
    refreshBadge
  }
}
